(function () {
    'use strict';

    angular
        .module('app')
        .controller('GroupsController', GroupsController);

    GroupsController.$inject = ['$state',];

    function GroupsController($state) {
        // var vm = this;


        activate();

        function activate() {
            // Run on load
            if ($state && $state.current && $state.current.name === 'groups') {
                $state.go('groups.list');
            }
        }
    }
})();